import KibernetesObject from './kibernetes_utils';

const NAME_UTIL = "KibernetesCookieBar";
const CONSENT_COOKIE_NAME = "kib-cookie-consent";
const ACCEPT_COOKIE_EXPIRE_DAYS = 180;
const REJECT_COOKIE_EXPIRE_DAYS = 180;

export default class KibernetesCookieBar {
	#selector;
	#elem;

	constructor( selector=undefined, ga=undefined, wai=undefined, at=undefined ) {
		this.#selector = selector;
		if ( !KibernetesObject.isUndef( this.#selector ) ) {
			this.#elem = new KibernetesObject({
				selector: this.#selector
			});
			const consent = this.#getConsentCookie();
			if ( !consent ) {
				this.#elem.show();
			} else {
				if ( consent == 1 ) {
					this.#funzionalitaDaAttivareConConsenso( ga, wai, at );
				}
			}
		}
	}

	#getConsentCookie() {
		var decodedC = decodeURIComponent( document.cookie );
		var i, x, y, ARRcookies = decodedC.split(';');
		for (i = 0; i < ARRcookies.length; i++) {
			x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
			y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
			x = x.replace(/^\s+|\s+$/g, '');
			if (x == CONSENT_COOKIE_NAME) {
				return y;
			}
		}
	}
	#setConsentCookie( value, exdays ) {
		const exdate = new Date();
		exdate.setTime( exdate.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
		const expire = 'expires=' + exdate.toUTCString();
		const path = 'path=/';
		const c_value = value + '; expires=' + exdate.toUTCString();
		document.cookie = CONSENT_COOKIE_NAME + '=' + value + ';' + expire + ';' + path;
	}
	#funzionalitaDaAttivareConConsenso( ga=undefined, wai=undefined, at=undefined ) {
		if ( !KibernetesObject.isUndef( ga ) ) {
			const script = document.createElement('script');
			script.onload = function () {
				window.dataLayer = window.dataLayer || [];
				function gtag(){
					dataLayer.push(arguments);
				}
				gtag('js', new Date());
				gtag('config', ga, {
					'anonymize_ip': true
				});
			};
			script.src = "https://www.googletagmanager.com/gtag/js?id=" + ga;
			document.body.appendChild(script);
		}
		if ( !KibernetesObject.isUndef( wai ) ) {
			var _paq = window._paq = window._paq || [];
			/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
			_paq.push(['trackPageView']);
			_paq.push(['enableLinkTracking']);
			_paq.push(['setSiteId', wai]);
			var u="https://ingestion.webanalytics.italia.it/";
			_paq.push(['setTrackerUrl', u+'matomo.php']);

			const script = document.createElement('script');
			script.onload = function () {
			};
			script.src = u + 'matomo.js';
			document.body.appendChild(script);

		}
		if ( !KibernetesObject.isUndef( at ) ) {
			//if (window.addthis){
				//window.addthis = null;
			//}
			//const script = document.createElement('script');
			//script.onload = function () {
				//if (typeof addthis !== 'undefined') {
					//addthis.init();
					//addthis.toolbox('.addthis_toolbox');
				//}
			//};
			//script.src = "https://s7.addthis.com/js/300/addthis_widget.js#pubid=" + at + "&domready=1&async=1";
			//document.body.appendChild(script);
		}
	}
	#closeCookieBar() {
		this.#elem.hide();
	}
	cookieRefused() {
		this.#setConsentCookie( 0, REJECT_COOKIE_EXPIRE_DAYS );
		this.#closeCookieBar();
	}
	cookieAccepted() {
		this.#setConsentCookie( 1, ACCEPT_COOKIE_EXPIRE_DAYS );
		this.#closeCookieBar();
	}
}
